import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../store/actions';

export const useHandleSidebarClose = () => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(actions.closeSidebar());
    }, [dispatch]);
};
